module.exports = __webpack_public_path__ + "static/headertext-a1ea83eb5cac4d0d80d29d230dd3bcdc.png";